function Sidebar() {
    return (
        <div></div>
    );
}

export default Sidebar;